import React from 'react'
import {Form, Input, DatePicker, Select} from "antd";
import config from "../../../config";

const {Option} = Select

const OfferFilter = () => {

    const bidStatus = [{key: 0, text: 'BEKLİYOR'}, {key: 1, text: 'OLUMLU'}, {key:2, text: 'OLUMSUZ'}];


    return(
        <React.Fragment>
            <Form.Item
                name={'bidNumber'}
                label={'Teklif No'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'customerName'}
                label={'Müşteri Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'startDate'}
                label={'Başlangıç Tarihi'}
                initialValue={''}
            >
                <DatePicker format={config.userDateFormat} />
            </Form.Item>
            <Form.Item
                name={'endDate'}
                label={'Bitiş Tarihi'}
                initialValue={''}
            >
                <DatePicker format={config.userDateFormat} />
            </Form.Item>
            <Form.Item
                name={'brandName'}
                label={'Marka Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'stockCode'}
                label={'Stok Kodu'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'stockName'}
                label={'Stok Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'representative'}
                label={'İlgili'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'bidStatus'}
                label={'Teklif Durumu'}
            >
                <Select>
                    {
                        bidStatus.map((item, index) => <Option key={index} value={item.key}>{item.text}</Option>)
                    }
                </Select>
            </Form.Item>
        </React.Fragment>
    )
}
export default OfferFilter